import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import logo from '../../../../assets/images/logo.svg';

const useStyles = makeStyles(theme => ({
    AppBar: {
        borderRight: '1rem solid #4D5D89',
        borderLeft: '1rem solid #4D5D89',
        //marginBottom: theme.spacing(2),
    },
    logo: {
        marginRight: theme.spacing(2),
        marginLeft: -6,
        [theme.breakpoints.down('xs')]: {
            width: 80,
            height: 'auto'
        }
    },
    grow: {
        flexGrow: 1,
    },
    separator: {
        width: 1,
        height: 28,
        backgroundColor: 'white',
        marginRight: theme.spacing(2)
    },
    title: {
        color: '#f4ce30',
        lineHeight: 1.2
    },
    subtitle: {
        color: '#CCC',
        [theme.breakpoints.down('xs')]: {
            display: 'none'
        }
    }
}));

export default function Header(props) {
    const classes = useStyles();

    return (
        <AppBar position='static' className={classes.AppBar}>
            <Toolbar>
                <img src={logo} alt='Unaerp' className={classes.logo} />
                <div className={classes.separator} />
                <div className={classes.grow}>
                    <Typography variant='caption' className={classes.subtitle}>
                        {props.subtitle}
                    </Typography>
                    <Typography variant='h6' color='inherit' className={classes.title}>
                        {props.title}
                    </Typography>
                </div>
                {props.children}
            </Toolbar>
        </AppBar>
    );
};

Header.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string
};